/* eslint-disable camelcase */
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import axios from 'axios'
import store from '@/store'
import components from '@/components'
import '@/assets/css/examples.css'
import vuetify from '@/plugins/vuetify'
import pipe from '@/pipe'
import $ from 'jquery'
import 'simplebar/dist/simplebar.min.css'
import 'simplebar'

import ResizeObserver from 'resize-observer-polyfill'
import VueSweetalert2 from 'vue-sweetalert2'

import '@/assets/css/calendar.min.css'
import '@/assets/css/styles.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.config.productionTip = false
Vue.use(VueSweetalert2)

window.ResizeObserver = ResizeObserver

Vue.prototype.$axios = axios
Vue.prototype.$ = $

const access_token = localStorage.getItem('access_token')
axios.defaults.baseURL = process.env.API
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
if (access_token) {
  axios.defaults.headers.common['Authorization'] = access_token
}

new Vue({
  vuetify,
  pipe,
  router,
  store,
  components,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js